import script from "./ApiEndpointSlideOver.vue?vue&type=script&setup=true&lang=js"
export * from "./ApiEndpointSlideOver.vue?vue&type=script&setup=true&lang=js"

import "./ApiEndpointSlideOver.vue?vue&type=style&index=0&id=3f727b06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f727b06"]])

export default __exports__